import {
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  TextField,
  Typography,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import { Container, Spinner } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { ToastContainer } from "react-toastify";
import { createApplicationAction } from "../../../redux/actions/ApplicationAction";
import notify from "../../../Notifcation";
import { useNavigate } from "react-router-dom";

const Shoplec = () => {
  const [desc, setdesc] = useState("");
  const [Nationalid, setNationalid] = useState("");
  const [RequestLec, setRequestLec] = useState("");
  const [TypeDoc, setTypeDoc] = useState("");
  const [Leas, setLeas] = useState("");
  const [Owner, setOwner] = useState("");

  const [Power, setPower] = useState("");
  const [Taxcard, setTaxcard] = useState("");
  const [Genastatus, setGenastatus] = useState("");
  const [OriginalLec, setOriginalLec] = useState("");
  const [Akdtanaz, setAkdtanaz] = useState("");
  const [tanazol, settanazol] = useState("");
  const [Miltarys, setMiltarys] = useState("");

  const [OfficialComm, setOfficialComm] = useState("");
  const [CertEmpp, setCertEmpp] = useState([]);
  const [EngReport, setEngReport] = useState("");
  const [qoroke, setqoroke] = useState("");
  const [BuildLec, setBuildLec] = useState("");
  const [Certmoqf, setCertmoqf] = useState("");
  const [CertTasarof, setCertTasarof] = useState("");

  const [ChoseServ, setChoseServ] = useState("");

  const [Others, setOthers] = useState([]);
  const navegate = useNavigate();
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(true);
  const [isPress, setisPress] = useState(false);
  const handleFileChangeNational = (e) => {
    // Convert FileList to Array
    const files = Array.from(e.target.files);
    setNationalid(files);
  };
  // const handleFileChangeelevakd = (e) => {
  //   // Convert FileList to Array
  //   const files = Array.from(e.target.files);
  //   setelevakd(files);
  // };
  const handleFileChangeOther = (e) => {
    // Convert FileList to Array
    const files = Array.from(e.target.files);
    setOthers(files);
  };
  const handleFileChangeCertEmpp = (e) => {
    // Convert FileList to Array
    const files = Array.from(e.target.files);
    setCertEmpp(files);
  };
  const handlesubmit = async (e) => {
    e.preventDefault();
    if (BuildLec === "" || Nationalid === "") {
      notify("من فضلك اكمل البيانات المطلوبة", "error");
      return;
    }
    setisPress(true);
    const formData = new FormData();
    formData.append("application_type", 7);
    formData.append("local_type", 6);
    formData.append("local_category", ChoseServ);
    formData.append("local_details", desc);

    formData.append("license_application", RequestLec);
    formData.append("tax_card", Taxcard);
    formData.append("official_extract_commercial_register", OfficialComm);
    formData.append("lease", Leas);
    formData.append("ownership_contract", Owner);
    formData.append("construction_license", BuildLec);
    formData.append("organization_benefit_store_position", Certmoqf);
    formData.append("real_estate_transactions_certificate", CertTasarof);
    formData.append("certified_engineering_report", EngReport);
    formData.append("sketch_showing_location", qoroke);
    formData.append("power_attoreny", Power);
    formData.append("original_license", OriginalLec);
    formData.append("criminal_record", Genastatus);
    formData.append("assignment_contract", Akdtanaz);
    formData.append("benefits_assignee_insurance", tanazol);
    formData.append("military_service", Miltarys);
    Nationalid.map((item) => {
      return formData.append("client_national_ids", item);
    });
    CertEmpp.map((item) => {
      return formData.append("health_certificate_employees", item);
    });
    Others.map((item) => {
      return formData.append("others", item);
    });
    await dispatch(createApplicationAction(formData));
    setLoading(false);
    setisPress(false);
    setdesc("");
    setNationalid("");
    setRequestLec("");
    setPower("");
    setTaxcard("");
    setOfficialComm("");
    setCertEmpp("");
    setEngReport("");
    setqoroke("");
    setBuildLec("");
    setCertmoqf("");
    setCertTasarof("");

    setChoseServ("");

    setOthers("");
  };
  const res = useSelector((state) => state.ApplicationReduser.createApp);

  useEffect(() => {
    if (loading === false) {
      setTimeout(() => setLoading(true), 1500);
      if (res) {
        if (res.status === 201 || res.status === 200) {
          if (res.data) {
            notify(res.data.message, "success");
            setTimeout(() => {
              navegate("/user/requestsuser");
            }, 3000);
          }
        } else if (res.status !== 201 || res.status !== 200) {
          if (res.data) {
            notify(res.data.message, "error");
          } else {
            notify("حدثة مشكلة حاول مرة اخرى", "error");
          }
        }
      }
    }
  }, [loading]);
  return (
    <Container>
      {" "}
      <h3 className="text-center mb-3 mt-3">خدمات المحلات التجارية</h3>
      <div className="inputs-container">
        <div className="inp-container">
          <FormControl fullWidth>
            <InputLabel id="demo-simple-select-label">
              {
                <Typography>
                  نوع الخدمة
                  <span style={{ color: "red", fontSize: "21px" }}>*</span>
                </Typography>
              }
            </InputLabel>
            <Select
              labelId="demo-simple-select-label"
              id="demo-simple-select"
              label={
                <Typography>
                  نوع الخدمة
                  <span style={{ color: "red", fontSize: "21px" }}>*</span>
                </Typography>
              }
              value={ChoseServ}
              onChange={(e) => setChoseServ(e.target.value)}
            >
              <MenuItem value={17}>فتح محل</MenuItem>
              <MenuItem value={18}>تشغيل محل صناعي أو تجاري</MenuItem>
              <MenuItem value={19}>تجديد ترخيص محل</MenuItem>
              <MenuItem value={20}>تعديل ترخيص محل صناعي او تجاري</MenuItem>
              <MenuItem value={21}>تعديل ترخيص محل عام</MenuItem>
              <MenuItem value={22}>
                تعديل ترخيص بأضافة شريك او اخراج شريك
              </MenuItem>
              <MenuItem value={23}>طلب نقل رخصة</MenuItem>
              <MenuItem value={24}>طلب الغاء رخصة</MenuItem>
            </Select>
          </FormControl>
        </div>
        {ChoseServ === 17 || ChoseServ === 18 ? (
          <>
            {" "}
            <div className="inp-container ">
              <TextField
                label={
                  <Typography>
                    البطاقة الشخصية
                    <span style={{ color: "red", fontSize: "21px" }}>*</span>
                  </Typography>
                }
                focused
                inputProps={{
                  multiple: true,
                }}
                type="file"
                onChange={handleFileChangeNational}
                variant="outlined"
              />
            </div>
            <div className="inp-container ">
              <TextField
                label={
                  <Typography>
                    صورة من رخصة البناء
                    <span style={{ color: "red", fontSize: "21px" }}>*</span>
                  </Typography>
                }
                focused
                // inputProps={{
                //   multiple: true,
                // }}
                type="file"
                onChange={(e) => setBuildLec(e.target.files[0])}
                variant="outlined"
              />
            </div>
            <div className="inp-container ">
              <TextField
                label={"طلب الترخيص"}
                focused
                // inputProps={{
                //   multiple: true,
                // }}
                type="file"
                onChange={(e) => setRequestLec(e.target.files[0])}
                variant="outlined"
              />
            </div>
            <div className="inp-container ">
              <TextField
                label={"صورة من البطاقة الضريبية"}
                focused
                // inputProps={{
                //   multiple: true,
                // }}
                type="file"
                onChange={(e) => setTaxcard(e.target.files[0])}
                variant="outlined"
              />
            </div>
            <div className="inp-container ">
              <TextField
                label={"مستخرج رسمي من المحل التجاري"}
                focused
                // inputProps={{
                //   multiple: true,
                // }}
                type="file"
                onChange={(e) => setOfficialComm(e.target.files[0])}
                variant="outlined"
              />
            </div>
            <div className="inp-container ">
              <TextField
                label={"شهادة صحية لجميع العاملين"}
                focused
                inputProps={{
                  multiple: true,
                }}
                type="file"
                onChange={handleFileChangeCertEmpp}
                variant="outlined"
              />
            </div>
            <div className="inp-container">
          <FormControl fullWidth>
            <InputLabel id="demo-simple-select-label">
              {
                <Typography>
                  نوع مستند الملكية
                  <span style={{ color: "red", fontSize: "21px" }}>*</span>
                </Typography>
              }
            </InputLabel>
            <Select
              labelId="demo-simple-select-label"
              id="demo-simple-select"
              label={
                <Typography>
                  نوع مستند الملكية
                  <span style={{ color: "red", fontSize: "21px" }}>*</span>
                </Typography>
              }
              value={TypeDoc}
              onChange={(e) => setTypeDoc(e.target.value)}
            >
              <MenuItem value={'i'}>إيجار</MenuItem>
              <MenuItem value={'m'}>ملكية</MenuItem>
            </Select>
          </FormControl>
        </div>
        {
          TypeDoc==='i'?(
            <div className="inp-container ">
            <TextField
              label={
                "صورة من مستند الايجار ساري لمدة مناسبة وموضح النشاط"
              }
              focused
              // inputProps={{
              //   multiple: true,
              // }}
              type="file"
              onChange={(e) => setLeas(e.target.files[0])}
              variant="outlined"
            />
          </div>
           
          ):TypeDoc==='m'?(
            <div className="inp-container ">
            <TextField
              label={
                "صورة من مستند الملكية ساري لمدة مناسبة وموضح النشاط"
              }
              focused
              // inputProps={{
              //   multiple: true,
              // }}
              type="file"
              onChange={(e) => setOwner(e.target.files[0])}
              variant="outlined"
            />
          </div>
          ):null
        }
           
            <div className="inp-container ">
              <TextField
                label={"افادة من التنظيم بموقف المحل (رخصة - تقنين)"}
                focused
                // inputProps={{
                //   multiple: true,
                // }}
                type="file"
                onChange={(e) => setCertmoqf(e.target.files[0])}
                variant="outlined"
              />
            </div>
            <div className="inp-container ">
              <TextField
                label={"شهادة تصرف عقاري"}
                focused
                // inputProps={{
                //   multiple: true,
                // }}
                type="file"
                onChange={(e) => setCertTasarof(e.target.files[0])}
                variant="outlined"
              />
            </div>
            <div className="inp-container ">
              <TextField
                label={"تقرير هندسي معتمد يثبت السلامة الأنشائية"}
                focused
                // inputProps={{
                //   multiple: true,
                // }}
                type="file"
                onChange={(e) => setEngReport(e.target.files[0])}
                variant="outlined"
              />
            </div>
            <div className="inp-container ">
              <TextField
                label={
                  "رسم كروكي يوضح مكان المحل يحتوي على (العنوان-الحي-الشارع-الرقم"
                }
                focused
                // inputProps={{
                //   multiple: true,
                // }}
                type="file"
                onChange={(e) => setqoroke(e.target.files[0])}
                variant="outlined"
              />
            </div>
            <div className="inp-container ">
              <TextField
                label={"توكيل"}
                focused
                // inputProps={{
                //   multiple: true,
                // }}
                type="file"
                onChange={(e) => setPower(e.target.files[0])}
                variant="outlined"
              />
            </div>
            <div className="inp-container ">
              <TextField
                label={"تفاصيل"}
                multiline
                type="text"
                value={desc}
                onChange={(e) => {
                  setdesc(e.target.value);
                }}
                variant="outlined"
              />
            </div>
            <div className="inp-container ">
              <TextField
                label={"اخرى"}
                focused
                inputProps={{
                  multiple: true,
                }}
                type="file"
                onChange={handleFileChangeOther}
                variant="outlined"
              />
            </div>
          </>
        ) : ChoseServ === 19 ||
          ChoseServ === 20 ||
          ChoseServ === 21 ||
          ChoseServ === 22 ? (
          <>
            {" "}
            <div className="inp-container ">
              <TextField
                label={
                  <Typography>
                    البطاقة الشخصية
                    <span style={{ color: "red", fontSize: "21px" }}>*</span>
                  </Typography>
                }
                focused
                inputProps={{
                  multiple: true,
                }}
                type="file"
                onChange={handleFileChangeNational}
                variant="outlined"
              />
            </div>
            <div className="inp-container ">
              <TextField
                label={"اصل الرخصة"}
                focused
                // inputProps={{
                //   multiple: true,
                // }}
                type="file"
                onChange={(e) => setOriginalLec(e.target.files[0])}
                variant="outlined"
              />
            </div>
            <div className="inp-container">
          <FormControl fullWidth>
            <InputLabel id="demo-simple-select-label">
              {
                <Typography>
                  نوع مستند الملكية
                  <span style={{ color: "red", fontSize: "21px" }}>*</span>
                </Typography>
              }
            </InputLabel>
            <Select
              labelId="demo-simple-select-label"
              id="demo-simple-select"
              label={
                <Typography>
                  نوع مستند الملكية
                  <span style={{ color: "red", fontSize: "21px" }}>*</span>
                </Typography>
              }
              value={TypeDoc}
              onChange={(e) => setTypeDoc(e.target.value)}
            >
              <MenuItem value={'i'}>إيجار</MenuItem>
              <MenuItem value={'m'}>ملكية</MenuItem>
            </Select>
          </FormControl>
        </div>
        {
          TypeDoc==='i'?(
            <div className="inp-container ">
            <TextField
              label={
                "صورة من مستند الملكية ساري لمدة مناسبة وموضح النشاط"
              }
              focused
              // inputProps={{
              //   multiple: true,
              // }}
              type="file"
              onChange={(e) => setOwner(e.target.files[0])}
              variant="outlined"
            />
          </div>
          ):TypeDoc==='m'?(
            <div className="inp-container ">
            <TextField
              label={
                "صورة من مستند الايجار ساري لمدة مناسبة وموضح النشاط"
              }
              focused
              // inputProps={{
              //   multiple: true,
              // }}
              type="file"
              onChange={(e) => setLeas(e.target.files[0])}
              variant="outlined"
            />
          </div>
          ):null
        }
            <div className="inp-container ">
              <TextField
                label={"الشهادة الصحية لجميع العاملين"}
                focused
                inputProps={{
                  multiple: true,
                }}
                type="file"
                onChange={handleFileChangeCertEmpp}
                variant="outlined"
              />
            </div>
            <div className="inp-container ">
              <TextField
                label={"صحيفة الحالة الجنائية"}
                focused
                // inputProps={{
                //   multiple: true,
                // }}
                type="file"
                onChange={(e) => setGenastatus(e.target.files[0])}
                variant="outlined"
              />
            </div>
            <div className="inp-container ">
              <TextField
                label={"توكيل"}
                focused
                // inputProps={{
                //   multiple: true,
                // }}
                type="file"
                onChange={(e) => setPower(e.target.files[0])}
                variant="outlined"
              />
            </div>
            <div className="inp-container ">
              <TextField
                label={"تفاصيل"}
                multiline
                type="text"
                value={desc}
                onChange={(e) => {
                  setdesc(e.target.value);
                }}
                variant="outlined"
              />
            </div>
            <div className="inp-container ">
              <TextField
                label={"اخرى"}
                focused
                inputProps={{
                  multiple: true,
                }}
                type="file"
                onChange={handleFileChangeOther}
                variant="outlined"
              />
            </div>
          </>
        ) : ChoseServ === 23 ? (
          <>
            <div className="inp-container ">
              <TextField
                label={
                  <Typography>
                    البطاقة الشخصية
                    <span style={{ color: "red", fontSize: "21px" }}>*</span>
                  </Typography>
                }
                focused
                inputProps={{
                  multiple: true,
                }}
                type="file"
                onChange={handleFileChangeNational}
                variant="outlined"
              />
            </div>
            <div className="inp-container ">
              <TextField
                label={"عقد التنازل ومصدق من الشهر العقاري"}
                focused
                // inputProps={{
                //   multiple: true,
                // }}
                type="file"
                onChange={(e) => setAkdtanaz(e.target.files[0])}
                variant="outlined"
              />
            </div>
            <div className="inp-container ">
              <TextField
                label={"اصل الرخصة"}
                focused
                // inputProps={{
                //   multiple: true,
                // }}
                type="file"
                onChange={(e) => setOriginalLec(e.target.files[0])}
                variant="outlined"
              />
            </div>
            <div className="inp-container ">
              <TextField
                label={"عقد ايجار محرر من المالك إلى المتنازل الية"}
                focused
                // inputProps={{
                //   multiple: true,
                // }}
                type="file"
                onChange={(e) => setLeas(e.target.files[0])}
                variant="outlined"
              />
            </div>
            <div className="inp-container ">
              <TextField
                label={"ما يفيد المتنازل الية بالتأمينات"}
                focused
                // inputProps={{
                //   multiple: true,
                // }}
                type="file"
                onChange={(e) => settanazol(e.target.files[0])}
                variant="outlined"
              />
            </div>
            <div className="inp-container ">
              <TextField
                label={"صحيفة الحالة الجنائية"}
                focused
                // inputProps={{
                //   multiple: true,
                // }}
                type="file"
                onChange={(e) => setGenastatus(e.target.files[0])}
                variant="outlined"
              />
            </div>
            <div className="inp-container ">
              <TextField
                label={"الموقف من التجنيد"}
                focused
                // inputProps={{
                //   multiple: true,
                // }}
                type="file"
                onChange={(e) => setMiltarys(e.target.files[0])}
                variant="outlined"
              />
            </div>
            <div className="inp-container ">
              <TextField
                label={"تفاصيل"}
                multiline
                type="text"
                value={desc}
                onChange={(e) => {
                  setdesc(e.target.value);
                }}
                variant="outlined"
              />
            </div>

            <div className="inp-container ">
              <TextField
                label={"اخرى"}
                focused
                inputProps={{
                  multiple: true,
                }}
                type="file"
                onChange={handleFileChangeOther}
                variant="outlined"
              />
            </div>
          </>
        ) : ChoseServ === 24 ? (
          <>
            <div className="inp-container ">
              <TextField
                label={
                  <Typography>
                    البطاقة الشخصية
                    <span style={{ color: "red", fontSize: "21px" }}>*</span>
                  </Typography>
                }
                focused
                inputProps={{
                  multiple: true,
                }}
                type="file"
                onChange={handleFileChangeNational}
                variant="outlined"
              />
            </div>
            <div className="inp-container ">
              <TextField
                label={"اصل الرخصة"}
                focused
                // inputProps={{
                //   multiple: true,
                // }}
                type="file"
                onChange={(e) => setOriginalLec(e.target.files[0])}
                variant="outlined"
              />
            </div>
            <div className="inp-container ">
              <TextField
                label={"تفاصيل"}
                multiline
                type="text"
                value={desc}
                onChange={(e) => {
                  setdesc(e.target.value);
                }}
                variant="outlined"
              />
            </div>

            <div className="inp-container ">
              <TextField
                label={"اخرى"}
                focused
                inputProps={{
                  multiple: true,
                }}
                type="file"
                onChange={handleFileChangeOther}
                variant="outlined"
              />
            </div>
          </>
        ) : null}
        {/* {ChoseServ===1?(
        <div className="inp-container">
          <FormControl fullWidth>
            <InputLabel id="demo-simple-select-label">
              {
                <Typography>
                  نوع الخدمة
                  <span style={{ color: "red", fontSize: "21px" }}>*</span>
                </Typography>
              }
            </InputLabel>
            <Select
              labelId="demo-simple-select-label"
              id="demo-simple-select"
              label={
                <Typography>
                  نوع الخدمة
                  <span style={{ color: "red", fontSize: "21px" }}>*</span>
                </Typography>
              }
              value={ChoseServSub}
              onChange={(e) => setChoseServSub(e.target.value)}
            >
              <MenuItem value={'construction'}>انشاء</MenuItem>
              <MenuItem value={'amendment'}>تعديل</MenuItem>
              <MenuItem value={'addition'}>اضافة</MenuItem>
              <MenuItem value={'external_finishes'}>تشطيبات خارجية</MenuItem>
              <MenuItem value={'complete'}>استكمال</MenuItem>
              <MenuItem value={'raising'}>تعلية</MenuItem>

            </Select>
          </FormControl>
        </div>
        ):(null)} */}

        <div className="inp-container "></div>
        <div className="inp-container "></div>
      </div>
      {isPress && loading ? (
        <button className="buttonadd">
          <Spinner />
        </button>
      ) : (
        <button className="buttonadd" onClick={handlesubmit}>
          {" "}
          استكمال الطلب
        </button>
      )}
      <ToastContainer />
    </Container>
  );
};

export default Shoplec;
